import type { Fields as Campaign } from 'models/Campaign'
import type { Metrics } from 'models/CampaignMetric'
import React from 'react'
import { I18n, Translate } from 'react-redux-i18n'
import withMetrics from 'scenes/CampaignCenter/Report/components/withMetrics'
import configs from 'scenes/CampaignCenter/Report/configs'
import HeaderBox from './HeaderBox'

type Props = {
  campaign: Campaign
  metrics?: Metrics
}

export const ConversionMetricContainer: React.FC<Props> = props => {
  const { campaign } = props
  const config = configs[campaign.type]
  const successCount = config.getSuccessCount(props)

  function notEnoughDataContent() {
    return (
      <span className="grey deprecated__body-text-2">
        <strong>
          <Translate value="thanx_campaigns.report.summary.conversion.not_enough_data" />
        </strong>
      </span>
    )
  }

  function content() {
    return (
      <span className="white body-text-1">
        <strong>
          <Translate
            value={`thanx_campaigns.report.campaign_types.${campaign.type}.conversion.description`}
            metric={I18n.l(successCount)}
          />
        </strong>
      </span>
    )
  }

  if (!successCount) {
    return (
      <HeaderBox
        className="grey-30-bkg"
        title={I18n.t('thanx_campaigns.report.summary.conversion.title')}
        content={notEnoughDataContent()}
      />
    )
  }

  const tooltip = I18n.t(
    `thanx_campaigns.report.campaign_types.${campaign.type}.conversion.tooltip`,
    {
      metric: I18n.l(successCount),
    }
  )
  return (
    <HeaderBox
      style={{ backgroundColor: config.color }}
      textClassName="white"
      title={I18n.t('thanx_campaigns.report.summary.conversion.title')}
      tooltip={tooltip}
      content={content()}
    />
  )
}

export default withMetrics(props => {
  return [configs[props.campaign.type].successMetric]
})(ConversionMetricContainer)
